/**
 * Sample React Native App
 * https://github.com/facebook/react-native
 *
 * Generated with the TypeScript template
 * https://github.com/react-native-community/react-native-template-typescript
 *
 * @format
 */
import React from 'react';
import {NativeBaseProvider} from 'native-base';
import {NavigationContainer} from '@react-navigation/native';
import {SafeAreaProvider} from 'react-native-safe-area-context';
import {theme} from './theme/native-base.theme';
import {
  NavigatorAnonymous,
  NavigatorSalesman,
  NavigatorDefaultSubClient,
  NavigatorEnchancedSubClient,
  NavigatorClient,
} from './navigators';
import {useMainProperties} from './hooks/app/useMainProperties';

const Main = () => {
  const {
    nativeBaseProviderProps,
    isAnonymous,
    isClient,
    isSalesMan,
    isDefaultSubClient,
    isEnchancedSubClient,
    groupOptions,
    navigationContainerProps,
  } = useMainProperties();

  return (
    <SafeAreaProvider>
      <NativeBaseProvider theme={theme} {...nativeBaseProviderProps}>
        <NavigationContainer {...navigationContainerProps}>
          {isAnonymous && isAnonymous() && <NavigatorAnonymous />}
          {isDefaultSubClient && isDefaultSubClient() && (
            <NavigatorDefaultSubClient {...{groupOptions}} />
          )}
          {isEnchancedSubClient && isEnchancedSubClient() && (
            <NavigatorEnchancedSubClient {...{groupOptions}} />
          )}
          {isClient && isClient() && <NavigatorClient {...{groupOptions}} />}
          {isSalesMan && isSalesMan() && (
            <NavigatorSalesman {...{groupOptions}} />
          )}
        </NavigationContainer>
      </NativeBaseProvider>
    </SafeAreaProvider>
  );
};
export default Main;
